import React, { useState } from "react";
import MuiTooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

/**
 * Mui tooltip component.
 * @param {String} className - Class name passed by Mui.
 * @param {ReactElement} children - Element to render inside tooltip.
 * @param {String} title - Text to show inside tooltip.
 * @param {String} placement - Where to place tooltip w.r.t to children. visit https://mui.com/components/tooltips/#positioned-tooltips for valid placements
 * @returns {ReactElement} Tooltip - returns tooltip component
 */
const Tooltip = styled(
    ({ className, children, title, placement }) => {
        const [showTooltip, setShowTooltip] = useState(false);

        const openTooltip = () => setShowTooltip(true);
        const closeTooltip = () => setShowTooltip(false);

        return (
            <MuiTooltip
                title={title}
                placement={placement}
                disableHoverListener={true}
                open={showTooltip}
                onMouseEnter={openTooltip}
                onMouseLeave={closeTooltip}
                classes={{ popper: className }}
                arrow
            >
                <div onClick={closeTooltip}>{children}</div>
            </MuiTooltip>
        );
    },
    {
        shouldForwardProp: (prop) => prop !== "truncate",
    }
)(({ theme, truncate }) => () => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: "unset",
        color: theme.palette.white,
        fontSize: "12px",
        lineHeight: "20px",
        padding: "8px",
        borderRadius: "6px",
        backgroundColor: "#404040",
        boxShadow: "0px 2px 20px rgba(146, 157, 171, 0.75)",
    },
    [`&`] : {
        zIndex: "999999999999999999",
        width: "calc(100% - 160px)",
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#404040",
        boxShadow: "0px 2px 20px rgba(146, 157, 171, 0.75)",
    },
    [`& a`]:{
        color: '#3c7dd9',
    },
}));

Tooltip.defaultProps = {
    title: "",
    placement: "top",
    truncate: false,
};

export default Tooltip;
